export type Size = 'xs' | 's' | 'm' | 'l';

export const getSize = (size: Size) => {
    switch (size) {
        case 'xs':
            return '16';
        case 's':
            return '18';
        case 'm':
            return '20';
        case 'l':
            return '22';
    }
};
